import { locales } from '../translations/locales';

/**
 * Translate entries in the format [[key]] to the corresponding value in the locales object
 * @param {String} entries - The text containing placeholders to be translated
 * @param {String} locale - The current locale to use for translations
 * @return {String} - The text with placeholders replaced by their corresponding translations
 */
export default function translateEntries(entries, locale) {
    if (!locale || !entries) {
        console.warn('Locale or entries are missing');
        return entries;
    }

    return entries.replace(/\[\[(.*?)\]\]/g, (_, key) => {
        const keys = key.split('.');
        let translation = locales[locale];

        for (const k of keys) {
            if (!translation?.[k]) {
                console.warn(`Translation not found for key: [[${key}]]`);
                return `[[${key}]]`; // Return the original placeholder if not found
            }
            translation = translation[k];
        }

        return translation;
    });
}
